import { getLocalDateTime } from '@sonar-software/sonar-ts-lib';
import React from 'react';
import { Row } from 'antd';
import { SonarText } from '@ui/text';

export interface DateTimeColumnProps {
	dateTime: string;
}

export const DateTimeColumn: React.FC<DateTimeColumnProps> = ({ dateTime }) => {
	if (!dateTime) {
		return null;
	}

	const localMoment = getLocalDateTime(dateTime);
	const formattedDate = localMoment.format('ll');
	const formattedTime = localMoment.format('LT');

	return (
		<>
			<Row>
				<SonarText>{ formattedDate }</SonarText>
			</Row>
			<Row>
				<SonarText>{ formattedTime }</SonarText>
			</Row>
		</>
	);
};
